import React, { useState } from 'react';
import styled from 'styled-components';
import { Wrapper, CenteredWrapper } from '../shared/commonStyles';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

import CoverModel202107 from '../../assets/image/cover_model/202107_placoledressy.png';
import CoverModel202108 from '../../assets/image/cover_model/202108_placoledressy.png';
import CoverModel202109 from '../../assets/image/cover_model/202109_placoledressy.png';
import CoverModel202110 from '../../assets/image/cover_model/202110_placoledressy.png';
import CoverModel202111 from '../../assets/image/cover_model/202111_placoledressy.png';
import CoverModel202112 from '../../assets/image/cover_model/202112_placoledressy.png';
import CoverModel202201 from '../../assets/image/cover_model/202201_placoledressy.png';
import CoverModel202203 from '../../assets/image/cover_model/202203_placoledressy.png';
import CoverModel202204 from '../../assets/image/cover_model/202204_placoledressy.png';
import CoverModel202205 from '../../assets/image/cover_model/202205_placoledressy.png';
import CoverModel202206 from '../../assets/image/cover_model/202206_placoledressy.png';
import CoverModel202207 from '../../assets/image/cover_model/202207_placoledressy.png';
import CoverModel202208 from '../../assets/image/cover_model/202208_placoledressy.png';
import CoverModel202209 from '../../assets/image/cover_model/202209_placoledressy.png';
import CoverModel202210 from '../../assets/image/cover_model/202210_placoledressy.png';
import CoverModel202211 from '../../assets/image/cover_model/202211_placoledressy.png';
import CoverModel202212 from '../../assets/image/cover_model/202212_placoledressy.png';
import CoverModel202301 from '../../assets/image/cover_model/202301_placoledressy.png';
import CoverModel202302 from '../../assets/image/cover_model/202302_placoledressy.png';
import CoverModel202303 from '../../assets/image/cover_model/202303_placoledressy.png';
import CoverModel202304 from '../../assets/image/cover_model/202304_placoledressy.png';
import CoverModel202305 from '../../assets/image/cover_model/202305_placoledressy.png';
import CoverModel202306_1 from '../../assets/image/cover_model/202306_placoledressy_1.png';
import CoverModel202306_2 from '../../assets/image/cover_model/202306_placoledressy_2.png';
import CoverModel202307_1 from '../../assets/image/cover_model/202307_placoledressy_1.png';
import CoverModel202307_2 from '../../assets/image/cover_model/202307_placoledressy_2.png';
import CoverModel202308_1 from '../../assets/image/cover_model/202308_placoledressy_1.png';
import CoverModel202308_2 from '../../assets/image/cover_model/202308_placoledressy_2.png';
import CoverModel202309_1 from '../../assets/image/cover_model/202309_placoledressy_1.png';
import CoverModel202309_2 from '../../assets/image/cover_model/202309_placoledressy_2.png';
import CoverModel202310_1 from '../../assets/image/cover_model/202310_placoledressy_1.png';
import CoverModel202310_2 from '../../assets/image/cover_model/202310_placoledressy_2.png';
import CoverModel202311_1 from '../../assets/image/cover_model/202311_placoledressy_1.png';
import CoverModel202311_2 from '../../assets/image/cover_model/202311_placoledressy_2.png';
import CoverModel202312_1 from '../../assets/image/cover_model/202312_placoledressy_1.png';
import CoverModel202312_2 from '../../assets/image/cover_model/202312_placoledressy_2.png';
import CoverModel202401_1 from '../../assets/image/cover_model/202401_placoledressy_1.png';
import CoverModel202401_2 from '../../assets/image/cover_model/202401_placoledressy_2.png';
import CoverModel202402_1 from '../../assets/image/cover_model/202402_placoledressy_1.png';
import CoverModel202402_2 from '../../assets/image/cover_model/202402_placoledressy_2.png';
import CoverModel202403_1 from '../../assets/image/cover_model/202403_placoledressy_1.png';
import CoverModel202403_2 from '../../assets/image/cover_model/202403_placoledressy_2.png';
import CoverModel202404_1 from '../../assets/image/cover_model/202404_placoledressy_1.png';
import CoverModel202404_2 from '../../assets/image/cover_model/202404_placoledressy_2.png';
import CoverModel202405_1 from '../../assets/image/cover_model/202405_placoledressy_1.png';
import CoverModel202405_2 from '../../assets/image/cover_model/202405_placoledressy_2.png';
import CoverModel202406_1 from '../../assets/image/cover_model/202406_placoledressy_1.png';
import CoverModel202406_2 from '../../assets/image/cover_model/202406_placoledressy_2.png';
import CoverModel202407_1 from '../../assets/image/cover_model/202407_placoledressy_1.png';
import CoverModel202407_2 from '../../assets/image/cover_model/202407_placoledressy_2.png';
import CoverModel202408_1 from '../../assets/image/cover_model/202408_placoledressy_1.jpg';
import CoverModel202408_2 from '../../assets/image/cover_model/202408_placoledressy_2.jpg';
import CoverModel202409_1 from '../../assets/image/cover_model/202409_placoledressy_1.jpg';
import CoverModel202409_2 from '../../assets/image/cover_model/202409_placoledressy_2.jpg';
import CoverModel202410_1 from '../../assets/image/cover_model/202410_placoledressy_1.jpg';
import CoverModel202410_2 from '../../assets/image/cover_model/202410_placoledressy_2.jpg';
import CoverModel202411_1 from '../../assets/image/cover_model/202411_placoledressy_1.jpg';
import CoverModel202411_2 from '../../assets/image/cover_model/202411_placoledressy_2.jpg';
import CoverModel202412_1 from '../../assets/image/cover_model/202412_placoledressy_1.jpg';
import CoverModel202412_2 from '../../assets/image/cover_model/202412_placoledressy_2.jpg';
import CoverModel202501_1 from '../../assets/image/cover_model/202501_placoledressy_1.jpg';
import CoverModel202501_2 from '../../assets/image/cover_model/202501_placoledressy_2.jpg';

const CoverModelWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 26px;
  
  img {
    width: calc(33.33% - 10px);
    margin: 0 5px 10px;
  }

  .view-more-button {
    font-family: Futura;
    font-size: 10px;
    letter-spacing: 2px;
    margin-top: 14px;
    padding: 8px 4px;
    border-bottom: 1px #000 solid;
    color: #000;
  }
`;

const SectionCoverModel = () => {
    const [showMore, setShowMore] = useState(false);
    const [hoveredImage, setHoveredImage] = useState(null);

    const coverModel = "カバーモデル ";
    const san = "さん";

    // 画像のパスの配列
    const images = [
        { path: CoverModel202501_1, path2: CoverModel202501_2, alt: `${coverModel}飯沼愛${san}` },
        { path: CoverModel202412_1, path2: CoverModel202412_2, alt: `${coverModel}田辺桃子${san}` },
        { path: CoverModel202411_1, path2: CoverModel202411_2, alt: `${coverModel}桜井日奈子${san}` },
        { path: CoverModel202410_1, path2: CoverModel202410_2, alt: `${coverModel}髙石あかり${san}` },
        { path: CoverModel202409_1, path2: CoverModel202409_2, alt: `${coverModel}安斉星来${san}` },
        { path: CoverModel202408_1, path2: CoverModel202408_2, alt: `${coverModel}大友花恋${san}` },
        { path: CoverModel202407_1, path2: CoverModel202407_2, alt: `${coverModel}齊藤京子${san}` },
        { path: CoverModel202406_1, path2: CoverModel202406_2, alt: `${coverModel}原菜乃華${san}` },
        { path: CoverModel202405_1, path2: CoverModel202405_2, alt: `${coverModel}畑芽育${san}` },
        { path: CoverModel202404_2, alt: `${coverModel}私たち結婚しました5` },
        { path: CoverModel202404_1, alt: `${coverModel}私たち結婚しました5` },
        { path: CoverModel202403_1, path2: CoverModel202403_2, alt: `${coverModel}白石聖${san}` },
        { path: CoverModel202402_1, path2: CoverModel202402_2, alt: `${coverModel}矢吹奈子${san}` },
        { path: CoverModel202401_1, path2: CoverModel202401_2, alt: `${coverModel}鶴嶋乃愛${san}` },
        { path: CoverModel202312_1, path2: CoverModel202312_2, alt: `${coverModel}影山優佳${san}` },
        { path: CoverModel202311_1, path2: CoverModel202311_2, alt: `${coverModel}久間田琳加${san}` },
        { path: CoverModel202310_1, path2: CoverModel202310_2, alt: `${coverModel}山田杏奈${san}` },
        { path: CoverModel202309_1, path2: CoverModel202309_2, alt: `${coverModel}森香澄${san}` },
        { path: CoverModel202308_1, path2: CoverModel202308_2, alt: `${coverModel}堀未央奈${san}` },
        { path: CoverModel202307_1, path2: CoverModel202307_2, alt: `${coverModel}莉子${san}` },
        { path: CoverModel202306_1, path2: CoverModel202306_2, alt: `${coverModel}箭内夢菜${san}` },
        { path: CoverModel202305, alt: `${coverModel}齊藤なぎさ${san}` },
        { path: CoverModel202304, alt: `${coverModel}高橋メアリージュン${san}` },
        { path: CoverModel202303, alt: `${coverModel}マギー${san}` },
        { path: CoverModel202302, alt: `${coverModel}玉城ティナ${san}` },
        { path: CoverModel202301, alt: `${coverModel}大原櫻子${san}` },
        { path: CoverModel202212, alt: `${coverModel}ダレノガレ明美${san}` },
        { path: CoverModel202211, alt: `${coverModel}近藤千尋${san}` },
        { path: CoverModel202210, alt: `${coverModel}宇野実彩子${san}` },
        { path: CoverModel202209, alt: `${coverModel}山本舞香${san}` },
        { path: CoverModel202208, alt: `${coverModel}私たち結婚しました3` },
        { path: CoverModel202207, alt: `${coverModel}岡崎紗絵${san}` },
        { path: CoverModel202206, alt: `${coverModel}石井杏奈${san}` },
        { path: CoverModel202205, alt: `${coverModel}生駒里奈${san}` },
        { path: CoverModel202204, alt: `${coverModel}名探偵コナン` },
        { path: CoverModel202203, alt: `${coverModel}関水渚${san}` },
        { path: CoverModel202201, alt: `${coverModel}舟山久美子${san}` },
        { path: CoverModel202112, alt: `${coverModel}篠田麻里子${san}` },
        { path: CoverModel202111, alt: `${coverModel}おのののか${san}` },
        { path: CoverModel202110, alt: `${coverModel}高橋愛${san}` },
        { path: CoverModel202109, alt: `${coverModel}Dream Ami${san}` },
        { path: CoverModel202108, alt: `${coverModel}わたなべ麻衣${san}` },
        { path: CoverModel202107, alt: `${coverModel}chay${san}` },
    ];

    // 表示する画像の数を制御する関数
    const getVisibleImages = () => {
        if (showMore) {
        return images;
        } else {
        return images.slice(0, 12);
        }
    };

    // 「View More」ボタンをクリックしたときの処理
    const handleViewMoreClick = () => {
      setShowMore(!showMore);
    };

    // カバーモデル画像をホバーした時の処理
    const handleMouseEnter = (index, image) => {
      if(image.path2) {
        setHoveredImage(index);
      }
      
    };
    // カバーモデル画像をホバーを外した時の処理
    const handleMouseLeave = (image) => {
      if(image.path2) {
        setHoveredImage(null);
      }
    };
    
    return (
      <Wrapper>
        <CoverModelWrapper>
          <FadeInFromBottom>
            <div>
              {getVisibleImages().map((image, index) => (
                <img
                  key={index}
                  src={hoveredImage === index ? image.path2 : image.path}
                  alt={image.alt}
                  onMouseEnter={() => handleMouseEnter(index, image)}
                  onMouseLeave={() => handleMouseLeave(image)}
                />
              ))}
            </div>
          </FadeInFromBottom>
          <CenteredWrapper>
            <button className='view-more-button' onClick={handleViewMoreClick}>
              {showMore ? 'close' : 'View more'}
            </button>
          </CenteredWrapper>
        </CoverModelWrapper>
      </Wrapper>
    );
  };
  
export default SectionCoverModel;
  